import {api, headers} from './api';

const RESOURCE = 'reviewer';

export const indexReviewer = () => api.get(RESOURCE, headers);

export const storeReviewer = (data) => api.post(RESOURCE, data, headers);

export const deleteReviewer = (id) => api.delete(RESOURCE+'/'+id, headers);